const escapeHtml = (text) =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

// split() with a capture group puts the matched URLs at the odd indexes.
// Trailing punctuation (. , ; : ! ? )) is not treated as part of the URL.
const URL_PATTERN = /(https?:\/\/[^\s<>"']*[^\s<>"'.,;:!?)])/g;

// URLs are clickable links that look like the surrounding text: same colour
// (also when visited / hovered / pressed) and underlined. The inline !important
// stops the browser's default blue / purple / red link colours from ever showing.
const LINK_STYLE =
  'color:inherit !important;text-decoration:underline !important;overflow-wrap:anywhere;';

// Escapes everything and turns http(s) URLs into links.
const toSafeHtml = (text) =>
  text
    .split(URL_PATTERN)
    .map((part, index) => {
      const safe = escapeHtml(part);
      return index % 2 === 1
        ? `<a href="${safe}" target="_blank" rel="noopener noreferrer" style="${LINK_STYLE}">${safe}</a>`
        : safe;
    })
    .join('');

/**
 * Plain-text invitation message -> HTML that looks like what gets copied.
 *   blank line  -> new paragraph
 *   single \n   -> <br>
 * The text is escaped first, so backend content can never inject markup.
 */
export const formatInviteMessageHtml = (message) =>
  String(message ?? '')
    .replace(/\r\n?/g, '\n')
    .trim()
    .split(/\n{2,}/)
    .map(
      (paragraph) =>
        `<p style="margin:0 0 12px;">${toSafeHtml(paragraph).replace(/\n/g, '<br>')}</p>`
    )
    .join('');
